import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'

import { Checklist } from '../../../../common/components/checklist'
import { getCookiesConsent } from '../common/cookies-utils'

const CookiesSettings = ({ intl, onChange }) => {
    const cookiesConsent = getCookiesConsent()

    const [targetedAd, setTargetedAd] = useState(cookiesConsent.targetedAd)
    const [analytics, setAnalytics] = useState(cookiesConsent.analytics)

    useEffect(() => {
        onChange({
            analytics,
            targetedAd
        })
    }, [onChange, targetedAd, analytics])

    const onChangeTargetedAd = () => {
        setTargetedAd(!targetedAd)
    }

    const onChangeAnalytics = () => {
        setAnalytics(!analytics)
    }

    return (
        <>
            <div>{intl.translate('ap_consent_preferences_description')}</div>
            <Checklist.Container>
                <Checklist.Item
                    checked={targetedAd}
                    onChange={onChangeTargetedAd}
                    header={intl.translate('ap_consent_preferences_option_1')}
                >
                    {intl.translate('ap_consent_preferences_option_1_desc')}
                </Checklist.Item>
                <Checklist.Item
                    checked={analytics}
                    onChange={onChangeAnalytics}
                    header={intl.translate('ap_consent_preferences_option_2')}
                >
                    {intl.translate('ap_consent_preferences_option_2_desc')}
                </Checklist.Item>
                <Checklist.Item checked={true} disabled header={intl.translate('ap_consent_preferences_option_3')}>
                    {intl.translate('ap_consent_preferences_option_3_desc')}
                </Checklist.Item>
            </Checklist.Container>
            <div>{intl.translate('ap_consent_preferences_additional')}</div>
        </>
    )
}

CookiesSettings.propTypes = {
    intl: PropTypes.objectOf(PropTypes.func),
    onChange: PropTypes.func
}

export { CookiesSettings }
